(ns teamoesterreich.admin-mode.ui-helper.block-edit-card
  (:require
    [reagent.core :as r]
    [reagent-material-ui.components :as mui]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.util.helper :as h] ;;(h/event-value e)
    [reagent-material-ui.icons.save :refer [save]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    ))



(defn get-it [content on-save-fn & [{:keys [title subText additional-button1 on-close-fn start-edit-mode] :as params}]]
  (let [!st (r/atom {:editor-content content :edit-mode (or start-edit-mode false)})
        !editor-mode (r/cursor !st [:edit-mode])
        !editor-content (r/cursor !st [:editor-content])]

    (fn []
      (let [line-ch? (not= content @!editor-content)]
        [mui/card
         (when title
           [mui/card-header {:title title}]
           )
         [mui/card-content
          {:style {:width "800px" :textAlign "left"}}

          [mui/text-field {
                           :style        {:backgroundColor (if line-ch? "#ffd6d2" "#ffffff")}
                           :fullWidth    true
                           :multiline    true
                           :rowsMax      20
                           :disabled     (not @!editor-mode)
                           :label        "Textblock"
                           :onChange     (fn [e] (reset! !editor-content (h/event-value e)))
                           :defaultValue content
                           }]]

         [mui/card-content
          (when subText
            [:span subText])]

         [mui/card-actions
          {:style {:marginTop "15px"}}
          (if @!editor-mode
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn []
                                      (swap! !st assoc :editor-content content :edit-mode false)
                                      (on-close-fn))
                         }
             "Abbrechen"]
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [edit])
                         :onClick   #(reset! !editor-mode true)
                         }
             "Bearbeiten"])

          (when @!editor-mode
            [mui/button {:variant   "contained"
                         :color "primary"
                         :startIcon (r/as-element [save])
                         :onClick   (fn []
                                      (on-save-fn @!editor-content)
                                      (swap! !st assoc :editor-content content :edit-mode false))
                         }
             "Speichern"])

          (when (and (not @!editor-mode) additional-button1)
            additional-button1)

          ]

         ]
        )


      )))